import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { AuthenticationService } from '@philips-internal/oswald-ui-core/lib/services';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/message-service';

import ConfigurationService from '../../../services/configuration-service';
import { phoneNumberFormatter } from '../../../utils';
import BaseController from '../../BaseController';
import { ImageAPI, PanelAPI, TextAPI } from '@philips-internal/oswald-ui-components';

@Controller({ component: 'layout-footer', fragment: 'footer' })
class FooterController extends BaseController {

  private THEME_DARK = '2';

  @Inject('image-footer')
  footerImage!: ImageAPI;

  @Inject('panel-info')
  infoPanel!: PanelAPI;

  @Inject('panel-powered')
  poweredPhilipsPanel!: PanelAPI;

  @Inject('text-address')
  addressText!: TextAPI;

  @Inject('text-email')
  emailText!: TextAPI;

  @Inject('text-phone')
  phoneText!: TextAPI;

  @Inject('panel-privacy-links')
  panelPrivacy!: PanelAPI;

  @OnMount({ target: ['layout-footer'] })
  onMount(): void {
    ConfigurationService.getLayoutConfigurationData().then(layoutData => {
      this.footerImage.setSrc(layoutData.dsUrlLogoFooter);
      const gradientColor = `linear-gradient(279deg, ${layoutData.dsFirstColor}, ${layoutData.dsSecondColor})`;
      this.infoPanel.setLightTheme(layoutData.ieFontColor === this.THEME_DARK);
      this.poweredPhilipsPanel.setLightTheme(layoutData.ieFontColor === this.THEME_DARK);
      this.infoPanel.setBackground(gradientColor);
      this.poweredPhilipsPanel.setBackground(gradientColor);
      this.addressText.setValue(layoutData.dsEndereco);
      this.emailText.setValue(`${MessageService.translate('$expression.$680093')}: ${layoutData.dsEmailRemetente}`);
      this.phoneText.setValue(`${MessageService.translate('$expression.$299149')}: ${phoneNumberFormatter(layoutData.nrFoneContato)}`);
    });
  }

  @OnMount({ target: 'panel-privacy' })
  onMountPanelPrivacidade(): void {
    if (AuthenticationService.isAuthenticated()) {
      this.panelPrivacy.setVisible(true);
    }
  }

  @OnClick({ target: 'link-terms' })
  onClickTermosDeUso(): void {
  }

  @OnClick({ target: 'link-privacy' })
  onClickAviso(): void {
  }

  @OnClick({ target: 'link-cookies' })
  onClickCookie(): void {
  }

}

export default FooterController;
